// Keep Artsy's native picker on valid, server-reported option combinations.
const selector = 'variant-picker[data-artsy-valid-options]';
const pending = new WeakMap();

function refresh(picker) {
  if (!picker?.matches(selector) || !picker.isConnected) return;
  const groups = [];
  for (const fieldset of picker.querySelectorAll('fieldset')) {
    const inputs = [...fieldset.querySelectorAll('input[type="radio"][data-option-available]')];
    if (!inputs.length) continue;
    for (const input of inputs) {
      const label = input.closest('label');
      if (label) label.hidden = input.dataset.optionAvailable === 'false';
    }
    groups.push({ element: fieldset, selected: inputs.find((input) => input.checked),
      first: inputs.find((input) => input.dataset.optionAvailable === 'true') });
  }
  for (const select of picker.querySelectorAll('select')) {
    const options = [...select.options];
    for (const option of options) {
      if (!option.hasAttribute('data-option-available')) continue;
      option.hidden = option.dataset.optionAvailable === 'false';
      option.disabled = option.hidden;
    }
    groups.push({ element: select, selected: select.selectedOptions[0],
      first: options.find((option) => option.dataset.optionAvailable === 'true'), select });
  }
  groups.sort((a, b) => a.element.compareDocumentPosition(b.element) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1);
  const invalid = groups.find(({ selected, first }) => first &&
    (!selected || selected.dataset.optionAvailable === 'false'));
  if (!invalid) { pending.delete(picker); return; }
  // Native availability is top-down. Correct only the first invalid group,
  // then let the existing picker fetch the next server-reported state.
  const key = `${picker.dataset.productId}:${groups.map(({ selected }) => selected?.dataset.optionValueId || '').join(',')}`;
  if (pending.get(picker) === key) return;
  pending.set(picker, key);
  const target = invalid.select || invalid.first;
  if (invalid.select) target.value = invalid.first.value;
  else invalid.first.checked = true;
  target.dispatchEvent(new Event('change', { bubbles: true }));
}

document.addEventListener('change', (event) => {
  if (!event.isTrusted) return;
  const picker = event.target?.closest?.(selector);
  if (picker) pending.delete(picker);
}, true);
document.addEventListener('variant:update', (event) => {
  const picker = event.target?.closest?.(selector);
  if (!picker) return;
  const productId = event.detail?.data?.productId;
  if (productId && String(productId) !== picker.dataset.productId) return;
  refresh(picker);
});
customElements.whenDefined('variant-picker').then(() => document.querySelectorAll(selector).forEach(refresh));
